import React from "react";
import {Uploader, UploadField} from '@navjobs/upload'

import {Button, Col, Form, FormGroup, Progress} from "reactstrap";
import connect from "react-redux/es/connect/connect";
import styled from "styled-components";
import ExampleUsage from "./ExampleUsage";


const CenteredCol = styled(Col)`
    margin-top: auto;
    margin-bottom: auto;
`;


class FileUploaderWithProgress extends React.Component {

    render() {
        const config = {
            fields: {
                workspaceNumber: this.props.workspaces.current.seqNumber,
            },
            fileName: 'file',
            url: '/api/monitored-uris/upload-excel-spec',
            method: 'POST'
        };

        return (


            <div>

                <ExampleUsage isFileUpload workspaceName={this.props.workspaces.current.name}/>
                <Uploader
                    request={config}
                    uploadOnSelection={true}>

                    {(args) => {

                        let {onFiles, progress, complete, error, response} = args;
                        // console.log("args ", args);

                        return <Form>

                            <FormGroup row>
                                <Col sm={3}>
                                    <UploadField onFiles={onFiles}>
                                        <Button onClick={onFiles} color={"info"}>Select File</Button>
                                    </UploadField>
                                </Col>


                                <CenteredCol sm={9}>
                                    <Progress color={error ? "danger" : "success"} value={progress}/>
                                    {progress === 100 && !complete ? 'Analysing...' : null}
                                    {complete ? 'Complete!' : null}
                                    {error ? 'Error: ' + response.message : null}
                                </CenteredCol>

                            </FormGroup>
                        </Form>
                    }}

                </Uploader>
            </div>


        )
    }
};


function mapsStateToProps(state) {
    return {"workspaces": state.workspaces};
}

function mapDispatchToProps(dispatch) {
    return {dispatch};
}


export default connect(mapsStateToProps, mapDispatchToProps)(FileUploaderWithProgress);




